import { createFileRoute, notFound, useRouter } from "@tanstack/react-router";
import { DatePage } from "@/components/pages/DatePage";
import { SiteShell } from "@/components/layout/SiteShell";
import { parseDateSlug, MONTH_NAMES_ID } from "@/lib/calendar/dates";

export const Route = createFileRoute("/detail/$slug")({
  loader: ({ params }) => {
    const ymd = parseDateSlug(params.slug);
    if (!ymd) throw notFound();
    return ymd;
  },
  head: ({ loaderData }) => {
    if (!loaderData) return {};
    const { y, m, d } = loaderData;
    const mn = MONTH_NAMES_ID[m - 1];
    const title = `Detail ${d} ${mn} ${y} - Hari Apa, Weton, Hijriah & Libur`;
    const desc = `Detail tanggal ${d} ${mn} ${y}: hari, weton Jawa, Hijriah, Bali, status tanggal merah, long weekend terkait, dan unduh PDF.`;
    const canonical = `https://hari.co.id/detail/${y}-${String(m).padStart(2, "0")}-${String(d).padStart(2, "0")}/`;
    return {
      meta: [
        { title },
        { name: "description", content: desc },
        { property: "og:title", content: title },
        { property: "og:description", content: desc },
        { property: "og:url", content: canonical },
      ],
      links: [{ rel: "canonical", href: canonical }],
    };
  },
  component: DetailPage,
  notFoundComponent: () => (
    <SiteShell>
      <div className="py-16 text-center">
        <h1 className="text-2xl font-bold">Halaman tidak ditemukan</h1>
        <p className="mt-2 text-muted-foreground">
          Format tanggal tidak valid. Coba contoh: <code>/detail/7-juni-2026</code>.
        </p>
      </div>
    </SiteShell>
  ),
  errorComponent: ({ error, reset }) => {
    const router = useRouter();
    return (
      <SiteShell>
        <div className="py-16 text-center">
          <h1 className="text-2xl font-bold">Terjadi kesalahan</h1>
          <p className="mt-2 text-sm text-muted-foreground">{error.message}</p>
          <button
            onClick={() => {
              router.invalidate();
              reset();
            }}
            className="mt-4 rounded-md bg-primary px-4 py-2 text-sm text-primary-foreground"
          >
            Coba lagi
          </button>
        </div>
      </SiteShell>
    );
  },
});

function DetailPage() {
  const { y, m, d } = Route.useLoaderData();
  return <DatePage y={y} m={m} d={d} />;
}